module.exports = __webpack_public_path__ + "static/media/4.23a98645.jpg";